

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TestsBlock extends Vue {
  @Prop({ type: Object, default: {} })
  readonly item!: any;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: Boolean, default: false })
  readonly isLinks!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isOpenBlock!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isResult!: boolean;

  get dateTestResult() {
    const d =
      new Date(this.item.result?.date_send_test_result).toLocaleDateString(
        'ru-RU',
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }
      ) || '';
    return d;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/legend/components/testsblock/TestsBlock.vue